import { getCurrentProject, getProjectsByUserId } from '@common/modules/projects/stores/projects.actions'
import { useProjectsStore } from '@common/modules/projects/stores/projects.store'

export async function syncProjectAfterCreate(
  workspaceId: string,
  createdProjectId?: string | null | void
): Promise<void> {
  await getProjectsByUserId(workspaceId)
  await getCurrentProject(workspaceId)

  if (useProjectsStore.getState().currentProject) {
    return
  }

  if (!createdProjectId) {
    return
  }

  const projectId = String(createdProjectId)
  const state = useProjectsStore.getState()
  const resolved =
    state.projects.find((project) => project.id === projectId) ??
    state.allProjects.find((project) => project.id === projectId) ??
    null

  if (resolved) {
    useProjectsStore.getState().setCurrentProject(resolved)
  }
}
